import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-orange/25" data-id="element-0" data-mp="23t8h0dnsuhcx">
      <MetaPixel data-id="element-1" data-mp="3mlja0y7k5j4n" />
      <AnnouncementBar data-id="element-2" data-mp="3ml14tc2x3ukl" />
      <main data-id="element-3" data-mp="3mkho1yp07c85">
        <HeroSection data-id="element-4" data-mp="3mjzsl4a6121a" />
        <StatsBar data-id="element-5" data-mp="3mjg7xft4rzjk" />
        <TransformationSection data-id="element-6" data-mp="3rc9ca2kot5v4" />
        <PainPointsSection data-id="element-7" data-mp="3rdaqgfx028h2" />
        <KitContentsSection data-id="element-8" data-mp="3rd1bdndhtlq5" />
        <InstantAccessSection data-id="element-9" data-mp="5yjsutqtdfe" />
        <BonusesSection data-id="element-10" data-mp="680tswt8a8y" />
        <PricingSection data-id="element-11" data-mp="5gel8p3rovc" />
        <GuaranteeSection data-id="element-12" data-mp="82ovg3doih9" />
        <TestimonialsSection data-id="element-13" data-mp="2zld1r8m3ndb0" />
        <FAQSection data-id="element-14" data-mp="2zm4vedw4z0yn" />
        <FinalCTASection data-id="element-15" data-mp="2zmwj72jhrued" />
      </main>
      <Footer data-id="element-16" data-mp="33mf25srr5vek" />
    </div>;
}